export default __webpack_public_path__ + "static/media/rewards-white.3a9f09a4.svg";